module.exports = __webpack_public_path__ + "static/media/Poppins-SemiBold.cce5625b.ttf";